<div class="editor-container" [style.height.vh]="dynamicContainerHeight">
  <div class="top-toolbar">
    <button class="icon-btn small" [matMenuTriggerFor]="templateMenu" *ngIf="!isEdit" title="Templates">
      <span class="material-icons">layers</span>
    </button>

    <mat-menu #templateMenu="matMenu" class="lib-menu" [overlapTrigger]="false">
      <button mat-menu-item (click)="changeTemplate({id:'new_template'})">
        Fresh Canvas
      </button>
      <button mat-menu-item *ngFor="let template of allTemplates" (click)="changeTemplate(template)">
        {{ template.name | titlecase }}
      </button>
    </mat-menu>

    <button class="icon-btn small" #sizeTrigger="matMenuTrigger" [matMenuTriggerFor]="sizeMenu" title="Size"
      *ngIf="!isEdit && templateId == 'new_template'">
      <span class="material-icons">photo_size_select_large</span>
    </button>
    <mat-menu #sizeMenu="matMenu" class="lib-menu" [overlapTrigger]="false">

      <div class="menu-search" (click)="$event.stopPropagation()">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search size" [(ngModel)]="sizeSearchText" />
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item *ngFor="let s of filteredCreativeSizes" (click)="changeCreativeSize({ value: s.value })">
        {{ s.label }}
      </button>

      <div *ngIf="filteredCreativeSizes.length === 0" class="no-results">
        No results found
      </div>
    </mat-menu>

    <button [ngClass]="{
      'icon-btn': true,
    }" [disabled]="!templateSelected" *ngIf="stepInput.component == 'dcoLibrary' " (click)="fileInput.click()"
      title="Upload Templates" type="file">
      <span class="material-icons">file_upload</span>
    </button>
    <input (change)="onUploadTemplate($event)" hidden #fileInput type="file" id="file"
      (click)="$event.target.value = null" />

    <button class="icon-btn" (click)="addText()" title="Text" [disabled]="!creativeWidth || !creativeHeight">
      <span class="material-icons">text_fields</span>
    </button>

    <button class="icon-btn small" [matMenuTriggerFor]="shapesMenu" title="Shapes"
      [disabled]="!creativeWidth || !creativeHeight">
      <span class="material-icons">category</span>
    </button>

    <mat-menu #shapesMenu="matMenu">
      <button mat-menu-item (click)="addRectangle()">
        <span class="material-icons">crop_16_9</span> Rectangle
      </button>
      <button mat-menu-item (click)="addCircle()">
        <span class="material-icons">circle</span> Circle
      </button>
      <button mat-menu-item (click)="addTriangle()">
        <span class="material-icons">change_history</span> Triangle
      </button>
      <button mat-menu-item (click)="addLine()">
        <span class="material-icons">horizontal_rule</span> Line
      </button>
    </mat-menu>

    <button [ngClass]="{'icon-btn': true, 'create-btn-disabled': allLibElements.length == 0}"
      [disabled]="allLibElements.length == 0 || !creativeWidth || !creativeHeight" [matMenuTriggerFor]="libElementsMenu"
      title="Insert Assets">
      <span class="material-icons">upload_file</span>
    </button>

    <mat-menu #libElementsMenu="matMenu" class="lib-menu" [overlapTrigger]="false">
      <div class="menu-search" (click)="$event.stopPropagation()">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search assets" [(ngModel)]="searchText" />
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item *ngFor="let item of filteredLibElements" (click)="uploadImageFromUrl(item, false)">
        {{ item.name }} ({{ item.asset_type }})
      </button>

      <div *ngIf="filteredLibElements.length === 0" class="no-results">
        No results found
      </div>
    </mat-menu>

    <!-- <button (click)="exportJSON()" class="icon-btn">
      <span class="material-icons">download</span>
    </button> -->
    <input type="file" #fileInput hidden (change)="uploadImage($event)">

    <button class="icon-btn" (click)="bringToFront()" title="Bring to Front"
      [disabled]="!creativeWidth || !creativeHeight">
      <span class="material-icons">flip_to_front</span>
    </button>

    <button class="icon-btn" (click)="sendToBack()" title="Send to Back" [disabled]="!creativeWidth || !creativeHeight">
      <span class="material-icons">flip_to_back</span>
    </button>

    <button class="icon-btn" (click)="deleteObject()" title="Delete" [disabled]="!creativeWidth || !creativeHeight">
      <span class="material-icons">delete</span>
    </button>
    <!--
    <button class="icon-btn" (click)="undo()" [disabled]="undoStack.length <= 1">
      <span class="material-icons">undo</span>
    </button>

    <button class="icon-btn" (click)="redo()" [disabled]="!redoStack.length">
      <span class="material-icons">redo</span>
    </button> -->

    <button [ngClass]="{'icon-btn': true, 'create-btn-disabled': feedColumns.length == 0}"
      [disabled]="feedColumns.length == 0 || !creativeWidth || !creativeHeight" [matMenuTriggerFor]="placeholderMenu"
      *ngIf="stepInput.component != 'dcoLibrary' " matTooltip="Placeholder" matTooltipPosition="above">
      <mat-icon>photo_size_select_actual</mat-icon>
    </button>


    <mat-menu #placeholderMenu="matMenu" class="lib-menu" [overlapTrigger]="false">
      <div class="menu-search" (click)="$event.stopPropagation()">
        <mat-icon>search</mat-icon>
        <input type="text" placeholder="Search placeholder" [(ngModel)]="placeholderSearchText" />
      </div>

      <mat-divider></mat-divider>

      <div class="menu-scroll">

        <button mat-menu-item *ngFor="let item of filteredPlaceholders" (click)="addPlaceholder(item)">

          <span style="text-transform: capitalize">
            {{ item.name }} ({{ item.type }})
          </span>

        </button>

        <div *ngIf="filteredPlaceholders.length === 0" class="no-results">
          No results found
        </div>

      </div>

    </mat-menu>

    <div class="size-display-first" *ngIf="creativeWidth && creativeHeight">
      <span>W: {{ creativeWidth | number:'1.0-0' }} px</span>
      <span class="ms-3">H: {{ creativeHeight | number:'1.0-0' }} px</span>
    </div>


    <div class="right-actions">
      <button class="icon-btn" (click)="onSyncClick()" title="Sync" id="sync-button-creative-editor"
        style="display: none;">
        <mat-icon>sync</mat-icon>
      </button>

      <button class="icon-btn" (click)="showPreview()" title="Preview">
        <mat-icon>preview</mat-icon>
      </button>
    </div>
  </div>

  <div class="properties-bar" *ngIf="
      canvas?.getActiveObject()?.type === 'textbox' ||
      canvas?.getActiveObject()?.type === 'image' ||
      canvas?.getActiveObject()?.customType === 'button' ||
      canvas?.getActiveObject()?.type === 'rect' ||
      canvas?.getActiveObject()?.type === 'circle' ||
      canvas?.getActiveObject()?.type === 'triangle' ||
      canvas?.getActiveObject()?.type === 'polygon'
  ">

    <div class="size-display" *ngIf="selectedObject">
      <span>W: {{ selectedWidth | number:'1.0-0' }} px</span>
      <span class="ms-3">H: {{ selectedHeight | number:'1.0-0' }} px</span>
    </div>

    <ng-container *ngIf="canvas?.getActiveObject()?.type === 'textbox'">

      <select [(ngModel)]="selectedFont" (ngModelChange)="applyFont($event)">
        <option *ngFor="let f of fonts" [value]="f.value">{{ f.label }}</option>
      </select>

      <div class="align-btn-group">
        <button class="icon-btn small" [class.active]="currentAlign === 'left'" (click)="setTextAlign('left')"
          title="Left Align">
          <span class="material-icons">format_align_left</span>
        </button>

        <button class="icon-btn small" [class.active]="currentAlign === 'center'" (click)="setTextAlign('center')"
          title="Center Align">
          <span class="material-icons">format_align_center</span>
        </button>

        <button class="icon-btn small" [class.active]="currentAlign === 'right'" (click)="setTextAlign('right')"
          title="Right Align">
          <span class="material-icons">format_align_right</span>
        </button>
      </div>

      <button class="icon-btn small" (click)="toggleUnderline()"
        [class.active]="canvas?.getActiveObject()?.underline === true" title="Underline">
        <span class="material-icons">format_underline</span>
      </button>

      <button class="icon-btn small" (click)="toggleItalic()"
        [class.active]="canvas?.getActiveObject()?.fontStyle === 'italic'" title="Italic">
        <span class="material-icons">format_italic</span>
      </button>

      <button class="icon-btn small" (click)="toggleBold()"
        [class.active]="canvas?.getActiveObject()?.fontWeight === 'bold'" title="Bold">
        <span class="material-icons">format_bold</span>
      </button>

      <div class="font-size-control">
        <button class="icon-btn small" (click)="adjustFontSize('decrease')" title="Decrease Font Size">−</button>

        <input type="number" [(ngModel)]="currentFontSize" min="10" max="150" (ngModelChange)="changeFontSize($event)"
          title="Font Size" />

        <button class="icon-btn small" (click)="adjustFontSize('increase')" title="Increase Font Size">+</button>
      </div>

      <div class="text-toolbar" style="display: flex; gap: 8px; align-items: center;">
        <!-- <button class="icon-btn small" (click)="decreaseIndent()" title="Decrease Indent">
          <span class="material-icons">format_indent_decrease</span>
        </button>
        <button class="icon-btn small" (click)="increaseIndent()" title="Increase Indent">
          <span class="material-icons">format_indent_increase</span>
        </button> -->

        <button class="icon-btn small" (click)="decreaseLineSpacing()" title="Decrease Line Spacing">
          <span class="material-icons">line_axis</span>
        </button>
        <button class="icon-btn small" (click)="increaseLineSpacing()" title="Increase Line Spacing">
          <span class="material-icons">height</span>
        </button>
      </div>

    </ng-container>

    <div class="controls shape-flex">

      <div class="control-block" *ngIf="selectedObject && selectedObject.type != 'image'">
        <input type="color" [value]="shapeColor" (change)="changeShapeColor($event)" [disabled]="!selectedObject"
          title="Shape Color" />
      </div>

      <button class="icon-btn" [matMenuTriggerFor]="clickUrlMenu" title="Configure Click URL"
        *ngIf="selectedObject && selectedObject.type == 'image' && selectedAssetType == 'button'">
        <mat-icon>link</mat-icon>
      </button>

      <mat-menu #clickUrlMenu="matMenu" class="click-url-menu">

        <button mat-menu-item *ngFor="let item of clicksFromFeed" (click)="configureClickUrl(item)">
          <span style="text-transform: capitalize">
            {{ item.name }} ({{ item.type }})
          </span>
        </button>

        <mat-divider></mat-divider>

        <div class="custom-url-wrapper" (click)="$event.stopPropagation()">
          <mat-form-field appearance="outline" class="ms-2 me-2">
            <mat-label>Custom Click URL</mat-label>
            <input matInput placeholder="https://example.com" [(ngModel)]="customClickUrl" />
          </mat-form-field>

          <button mat-raised-button class="mt-2 ms-2 icon-btn" (click)="setCustomClickUrl()">
            Apply
          </button>
        </div>
      </mat-menu>

      <div class="control-block" *ngIf="
              selectedObject &&
              (selectedObject.type === 'rect' ||
               selectedObject.customType === 'button')
           ">
        <input type="number" [value]="selectedRadius" min="0" max="100" (input)="changeShapeRadius($event)"
          title="Shape Radius" />
      </div>
    </div>
  </div>

  <div class="canvas-wrapper">
    <div class="creative-boundary" [style.width.px]="creativeWidth" [style.height.px]="creativeHeight">
      <canvas #canvasRef></canvas>
    </div>
  </div>
</div>